import React from "react";
import { AdministrationWidgetPanelTemplate } from "themes/common/components";

function AdministrationWidgetPanel(props) {
    return <AdministrationWidgetPanelTemplate {...props} />;
}

export default AdministrationWidgetPanel;
